/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Who_1_DInputs */

const en_cp_who_1_d = /** @type {(inputs: Cp_Who_1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop writing proposals without a product. Write the PRD, split it into tasks with pass/fail criteria, build with Claude Code, Cursor, Copilot, or by hand — and have evidence for the pitch, the report, and your portfolio.`)
};

const id_cp_who_1_d = /** @type {(inputs: Cp_Who_1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berhenti menulis proposal tanpa produk. Tulis PRD, pecah jadi task dengan kriteria lulus/gagal, kerjakan dengan Claude Code, Cursor, Copilot, atau manual — dan punya bukti untuk pitch, laporan, dan portofolio.`)
};

/**
* | output |
* | --- |
* | "Stop writing proposals without a product. Write the PRD, split it into tasks with pass/fail criteria, build with Claude Code, Cursor, Copilot, or by hand — a..." |
*
* @param {Cp_Who_1_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_who_1_d = /** @type {((inputs?: Cp_Who_1_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Who_1_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_who_1_d(inputs)
	return en_cp_who_1_d(inputs)
});